import type { IconProps } from './typesIcons'

export default function SearchTermMagnifyingGlass({
  height = 16,
  width = 17,
  color = 'black',
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33333 3C4.66396 3 2.5 5.16396 2.5 7.83333C2.5 10.5027 4.66396 12.6667 7.33333 12.6667C10.0027 12.6667 12.1667 10.5027 12.1667 7.83333C12.1667 5.16396 10.0027 3 7.33333 3ZM1.5 7.83333C1.5 4.61167 4.11167 2 7.33333 2C10.555 2 13.1667 4.61167 13.1667 7.83333C13.1667 11.055 10.555 13.6667 7.33333 13.6667C4.11167 13.6667 1.5 11.055 1.5 7.83333Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7465 11.2465C10.9418 11.0513 11.2584 11.0513 11.4537 11.2465L14.3537 14.1465C14.5489 14.3418 14.5489 14.6584 14.3537 14.8537C14.1584 15.0489 13.8418 15.0489 13.6465 14.8537L10.7465 11.9537C10.5513 11.7584 10.5513 11.4418 10.7465 11.2465Z"
        fill={color}
      />
    </svg>
  )
}
